import { render, staticRenderFns } from "./OneServerOption.vue?vue&type=template&id=60ec1d00&scoped=true&"
import script from "./OneServerOption.vue?vue&type=script&lang=js&"
export * from "./OneServerOption.vue?vue&type=script&lang=js&"
import style0 from "./OneServerOption.vue?vue&type=style&index=0&id=60ec1d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec1d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ec1d00')) {
      api.createRecord('60ec1d00', component.options)
    } else {
      api.reload('60ec1d00', component.options)
    }
    module.hot.accept("./OneServerOption.vue?vue&type=template&id=60ec1d00&scoped=true&", function () {
      api.rerender('60ec1d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/OneServerOption.vue"
export default component.exports